import script from "./Dialog-Warning.vue?vue&type=script&setup=true&lang=js"
export * from "./Dialog-Warning.vue?vue&type=script&setup=true&lang=js"

import "./Dialog-Warning.vue?vue&type=style&index=0&id=05023aa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05023aa4"]])

export default __exports__